import { Box, Button, Paper, styled } from '@mui/material';

export const MiniChatContainer = styled(Box)<{ isDark?: boolean; expanded?: boolean }>(({ isDark, expanded }) => ({
  width: expanded ? '350px' : '300px',
  height: expanded ? '400px' : 'auto',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: isDark ? '#1D2939' : '#FFFFFF',
  overflow: 'hidden',
  transition: 'width 0.25s ease, height 0.25s ease',
}));

export const MiniChatHeader = styled(Box)<{ isDark?: boolean }>(({ isDark }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 14px',
  borderBottom: `1px solid ${isDark ? '#344054' : '#EAECF0'}`,
  flexShrink: 0,
}));

export const MiniChatMessages = styled(Box)(() => ({
  flex: 1,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px',
  minHeight: 0,
}));

export const MiniMessageContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isUser',
})<{ isUser: boolean }>(({ isUser }) => ({
  display: 'flex',
  alignSelf: isUser ? 'flex-end' : 'flex-start',
  maxWidth: '85%',
}));

export const MiniMessageBubble = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isUser' && prop !== 'isDark',
})<{ isUser: boolean; isDark?: boolean }>(({ isUser, isDark }) => ({
  padding: '8px 12px',
  borderRadius: '8px',
  wordBreak: 'break-word',
  boxShadow: 'none',
  fontSize: '13px',
  lineHeight: '1.5',
  whiteSpace: 'pre-wrap',
  backgroundColor: isUser
    ? '#3650DE'
    : isDark
      ? '#344054'
      : '#F2F4F7',
  color: isUser
    ? '#FFFFFF'
    : isDark
      ? '#D0D5DD'
      : '#101828',
}));

export const MiniChatInputArea = styled(Box)<{ isDark?: boolean }>(({ isDark }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 12px',
  borderTop: `1px solid ${isDark ? '#344054' : '#EAECF0'}`,
  flexShrink: 0,
}));

export const MiniTypingIndicator = styled(Box)<{ isDark?: boolean }>(({ isDark }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 8px',
  alignSelf: 'flex-start',
  '& .dot': {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: isDark ? '#98A2B3' : '#475467',
    animation: 'promptAssistantTyping 1.4s infinite',
    '&:nth-of-type(2)': {
      animationDelay: '0.2s',
    },
    '&:nth-of-type(3)': {
      animationDelay: '0.4s',
    },
  },
  '@keyframes promptAssistantTyping': {
    '0%, 100%': {
      transform: 'translateY(0)',
      opacity: 0.2,
    },
    '50%': {
      transform: 'translateY(-4px)',
      opacity: 1,
    },
  },
}));

export const OutputPreviewCard = styled(Box)<{ isDark?: boolean }>(({ isDark }) => ({
  margin: '4px 12px 8px',
  padding: '10px 12px',
  borderRadius: '8px',
  border: `1px solid ${isDark ? '#475467' : '#D0D5DD'}`,
  backgroundColor: isDark ? '#101828' : '#F9FAFB',
  fontSize: '12px',
  lineHeight: '1.6',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  color: isDark ? '#D0D5DD' : '#344054',
  maxHeight: '140px',
  overflowY: 'auto',
  fontFamily: 'monospace',
}));

export const InsertButton = styled(Button)(() => ({
  margin: '0 12px 8px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '13px',
  borderRadius: '8px',
  backgroundColor: '#3650DE',
  color: '#FFFFFF',
  padding: '6px 16px',
  '&:hover': {
    backgroundColor: '#2A40B0',
  },
}));
